import CaseCreator from './CaseCreator.js';
export default CaseCreator;
//# sourceMappingURL=index.js.map